import { render, staticRenderFns } from "./scanner-page.vue?vue&type=template&id=4b5acf7c"
import script from "./scanner-page.vue?vue&type=script&lang=js"
export * from "./scanner-page.vue?vue&type=script&lang=js"
import style0 from "./scanner-page.vue?vue&type=style&index=0&id=4b5acf7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports